import api from "../api";

export const getSubAdmins = (params) =>
  api.get("/sub_admin", { params });

export const addSubAdmin = (payload) =>
  api.post("/sub_admin/add", payload);

export const updateSubAdmin = (id, payload) =>
  api.post(`/sub_admin/edit/${id}`, payload);

export const deleteSubAdmin = (id) =>
  api.post(`/sub_admin/delete/${id}`);

export const restoreSubAdmin = (id) =>
  api.post(`/sub_admin/restore/${id}`);

